"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    select: {},
    _disabled: {
        textColor: 'gray.400 !important',
    },
};
const FormInputSelectStyle = {
    baseStyle,
};
exports.default = FormInputSelectStyle;
